import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-opa-header',
  imports: [RouterModule],
  templateUrl: './opa-header.component.html',
  styleUrls: ['./opa-header.component.scss'],
})
export class OpaHeaderComponent {}
